export const defaultQueryResult = {
  status: "loading",
  isError: false,
  isLoading: true,
  isSuccess: false,
  error: null
};
